import { gql } from '@apollo/client';

export const DOCTOR_LIST = gql`
  query PractitionerList($_count: Int, $_offset: Int) {
    list: PractitionerList(_count: $_count, _offset: $_offset) {
      id
      name {
        prefix
        suffix
        family
        given
      }
      telecom {
        use
        value
        system
        rank
      }
      address {
        city
        country
        state
        district
        postalCode
        line
        text
      }
      active
      practitionerRole: PractitionerRoleList(_reference: practitioner) {
        id
        code {
          coding {
            system
            code
            display
          }
        }
        specialty {
          coding {
            system
            code
            display
          }
        }
      }
    }
  }
`;

export const GET_DOCTOR_BY_ID = gql`
  query Practitioner($id: ID!) {
    doctor: Practitioner(id: $id) {
      id
      name {
        prefix
        suffix
        family
        given
      }
      telecom {
        use
        value
        system
        rank
      }
      address {
        city
        country
        state
        district
        postalCode
        line
        text
      }
      active
      gender
      birthDate
      practitionerRole: PractitionerRoleList(_reference: practitioner) {
        id
        code {
          coding {
            system
            code
            display
          }
        }
        specialty {
          coding {
            system
            code
            display
          }
        }
      }
    }
  }
`;

export const DOCTOR_FEATURE_DROPDOWN_LIST = gql`
  query ValueSets {
    specialization: ValueSetList(
      url: "https://fluentinhealth.com/FHIR/ValueSet/FACT-spe"
    ) {
      id
      compose {
        include {
          concept {
            code
            display
          }
          system
        }
      }
    }
    countries: ValueSetList(
      url: "https://fluentinhealth.com/FHIR/ValueSet/Countries"
    ) {
      id
      compose {
        include {
          concept {
            code
            display
          }
        }
      }
    }
    speciality: ValueSetList(
      url: "https://fluentinhealth.com/FHIR/ValueSet/FACT-sty"
    ) {
      id
      compose {
        include {
          concept {
            code
            display
          }
        }
      }
    }
    educationTitle: ValueSetList(
      url: "https://fluentinhealth.com/FHIR/ValueSet/FACT-spe"
    ) {
      id
      compose {
        include {
          concept {
            code
            display
          }
        }
      }
    }
  }
`;

export const SPECIALTY_VALUE_SET = gql`
  query ValueSets {
    speciality: ValueSetList(
      url: "https://fluentinhealth.com/FHIR/ValueSet/FACT-sty"
    ) {
      id
      compose {
        include {
          concept {
            code
            display
          }
        }
      }
    }
  }
`;

export const GET_CITIES_BY_COUNTRY = gql`
  query GetCitiesByUrl($url: String!) {
    cities: ValueSetList(url: $url) {
      id
      compose {
        include {
          concept {
            code
            display
          }
        }
      }
    }
  }
`;

export const GET_STATES_BY_COUNTRY = gql`
  query GetStatesByCountry($url: String!) {
    states: ValueSetList(url: $url) {
      id
      compose {
        include {
          system
          concept {
            code
            display
          }
        }
      }
    }
  }
`;
